export default __webpack_public_path__ + "static/media/answer-picture-blue.5d5a5b6f.png";